import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { InvocationRecord } from "../ActionRecord";

export const getQueryKey = (invocationId: string | null) => {
  if (invocationId === null) {
    return ["invocationRecord"];
  }

  return ["invocationRecord", invocationId];
};

export function useInvocation(invocationId: string | null) {
  const { actionService } = useDomainServices();

  return useQuery<InvocationRecord, Error>({
    queryKey: getQueryKey(invocationId || null),
    queryFn: ({ signal }) => {
      if (invocationId === null) {
        return Promise.reject(new Error("Invalid invocationId"));
      }

      return actionService.getInvocation(invocationId, undefined, {
        abortSignal: signal,
      });
    },
    enabled: invocationId !== null,
  });
}
